export default __webpack_public_path__ + "static/media/ru-dpr.a95828e9.svg";